import React from 'react';
import { Check, TrendingUp, Calendar } from 'lucide-react';

const ResultView = ({
    difficulty,
    stats,
    srsResult,
    onRetry,
    onGoHome
}) => {
    return (
        <div className="min-h-screen bg-slate-50 dark:bg-slate-950 flex items-center justify-center p-6 font-sans transition-colors">
            <div className="max-w-2xl w-full bg-white dark:bg-slate-900 rounded-2xl shadow-xl border border-slate-100 dark:border-slate-800 p-8 text-center transition-colors">
                <Check className="w-16 h-16 mx-auto mb-4 text-green-500 bg-green-100 dark:bg-green-900/30 rounded-full p-3" />
                <h2 className="text-3xl font-bold text-slate-800 dark:text-slate-100">練習完成！</h2>
                <p className="text-slate-500 dark:text-slate-400 mt-2">{difficulty.toUpperCase()} 模式挑戰成功</p>
                <div className="grid grid-cols-3 gap-4 my-8">
                    <div className="bg-slate-50 dark:bg-slate-800 p-4 rounded-xl"><div className="text-sm text-slate-500 dark:text-slate-400">準確率</div><div className="text-2xl font-bold text-indigo-600 dark:text-indigo-400">{stats.accuracy}%</div></div>
                    <div className="bg-slate-50 dark:bg-slate-800 p-4 rounded-xl"><div className="text-sm text-slate-500 dark:text-slate-400">WPM</div><div className="text-2xl font-bold text-indigo-600 dark:text-indigo-400">{stats.wpm}</div></div>
                    <div className="bg-slate-50 dark:bg-slate-800 p-4 rounded-xl"><div className="text-sm text-slate-500 dark:text-slate-400">錯誤</div><div className="text-2xl font-bold text-red-500 dark:text-red-400">{stats.errorCount}</div></div>
                </div>

                {srsResult && (
                    <div className="mb-8 p-4 bg-emerald-50 dark:bg-emerald-900/20 border border-emerald-100 dark:border-emerald-800 rounded-xl text-emerald-700 dark:text-emerald-400 flex flex-col items-center gap-2">
                        <div className="flex items-center gap-2 font-bold">
                            <TrendingUp className="w-5 h-5" />
                            <span>{srsResult.message}</span>
                        </div>
                        <div className="text-sm flex items-center gap-1">
                            <Calendar className="w-4 h-4" />
                            <span>下次複習時間：{srsResult.daysToAdd} 天後</span>
                        </div>
                    </div>
                )}

                <div className="flex gap-4">
                    <button onClick={onRetry} className="flex-1 py-3 border border-indigo-600 dark:border-indigo-500 text-indigo-600 dark:text-indigo-400 rounded-xl font-bold hover:bg-indigo-50 dark:hover:bg-indigo-900/30 transition-colors">再來一次</button>
                    <button onClick={onGoHome} className="flex-1 py-3 bg-indigo-600 text-white rounded-xl font-bold hover:bg-indigo-700 transition-colors shadow-lg shadow-indigo-200 dark:shadow-none">回到首頁</button>
                </div>
            </div>
        </div>
    );
};

export default ResultView;
